
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import SPUService from '@/services/spu.service';

@Component({})
export default class RebuildSPUModal extends Vue {
  @Prop()
  copyVisible!: boolean;

  @Prop()
  shopId!: string;

  @Ref()
  readonly copyForm!: FormModel;

  @lazyInject(SPUService)
  spuService!: SPUService;

  @lazyInject(ShopService)
  shopService!: ShopService;

  copyLoading = false;

  disabled = false;

  /**
   * 确认复制
   */
  async handleCopyOk() {
    const param = {
      targetShopId: this.shopId,
    };
    const msg = await this.spuService.postShopSpusRebuild(param);
    if (msg) {
      this.afterCopy(msg);
    }
  }

  /**
   * 关闭复制
   */
  handleCopyClose() {
    this.$emit('close');
  }

  afterCopy(msg: string) {
    this.$emit('refresh');
    this.$message.success(msg);
  }
}
